import React from "react";
import { useDispatch } from "react-redux";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import Button from "pages/_components/Button";
import * as configUtils from "util/config";
import { Link } from "react-router-dom";
import getCellPlacement from "util/helpers/table";
import CustomText from "pages/_components/CustomText/CustomText";
import { bool, number, string } from "prop-types";
import { actions as loansActions } from "reducers/loans";

const LoansCard = ({ loanType, isDesktop, availableAmount, rates, showSimulateButton }) => {
    const dispatch = useDispatch();

    const currency = "ARS";
    const duration = configUtils.get(`unsecured.loans.${loanType}.duration`);

    const columns = isDesktop ? 8 : 2;
    const rows = isDesktop ? 1 : 8;
    const columnsTemplate = isDesktop ? `repeat(8, 1fr) ` : "1fr";
    const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });
    const rateType = configUtils.get(`unsecured.loans.${loanType}.rateType`);
    const loanRate = rates ? rates.find((rate) => duration >= rate.plazoDesde && duration <= rate.plazoHasta)?.tasa?.toFixed(2) : "0";

    const handleClick = () => {
        dispatch(loansActions.requestUnsecuredLoan(loanType, loanRate, availableAmount));
    };

    return (
        <GridTable.Container
            className="loans__item"
            columns={columns}
            rows={rows}
            renderAs={showSimulateButton ? Link : "div"}
            columnsTemplate={columnsTemplate}
            onClick={() => {
                handleClick();
            }}
            to="/requestUnsecuredLoan">
            <GridTable.Data
                columnWidth={2}
                rowWidth={1}
                lassName="modalities"
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 1)}>
                <CustomData
                    titleText=" "
                    titleTextType="STRING"
                    valueText={<CustomText text={`unsecured.loans.${loanType}.title`} textType="I18N" />}
                    valueClass="custom-text-loan-type font-weight-600"
                />
            </GridTable.Data>

            <GridTable.Data
                columnWidth={1}
                rowWidth={1}
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 3)}>
                <CustomData
                    titleText="loans.rateType.title.label"
                    titleTextType="I18N"
                    valueText={<CustomText text={`unsecured.loans.rateType.${rateType}`} textType="I18N" />}
                />
            </GridTable.Data>

            <GridTable.Data
                columnWidth={1}
                rowWidth={1}
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 4)}>
                <CustomData titleText="loans.rate.title.label" titleTextType="I18N" valueText={`${loanRate}%`} />
            </GridTable.Data>

            <GridTable.Data
                columnWidth={2}
                rowWidth={1}
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 5)}>
                <CustomData
                    titleText="loans.duration.title.label"
                    titleTextType="I18N"
                    valueText={`${configUtils.get(`unsecured.loans.${loanType}.duration`)} meses`}
                />
            </GridTable.Data>

            <GridTable.Data
                columnWidth={2}
                rowWidth={1}
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 6)}>
                <CustomData
                    titleText="loans.amount.title.label"
                    titleTextType="I18N"
                    valueText={<FormattedAmount currency={currency} quantity={availableAmount} />}
                    valueTextType="STRING"
                    titleClass="loans-padding"
                    valueClass="loans-padding"
                />
            </GridTable.Data>

            <GridTable.Data
                columnWidth={1}
                rowWidth={1}
                alignX="left"
                alignY="start"
                flexDirection={isDesktop ? "row" : "column"}
                {...getCellProps(1, 8)}>
                {showSimulateButton &&
                    <Button
                        image="images/figma/icon/arrow-right.svg"
                        bsStyle="link"
                        style={{ flexDirection: "row-reverse", paddingLeft: null, fill: "#172b62" }}
                        label="loans.simulate.button.label"
                        onClick={() => {
                            handleClick();
                        }}
                    />}
            </GridTable.Data>
        </GridTable.Container>
    );
};

LoansCard.propTypes = {
    isDesktop: bool.isRequired,
    isFirst: bool.isRequired,
    loanType: string.isRequired,
    availableAmount: number.isRequired,
    showSimulateButton: bool.isRequired,
};

export default LoansCard;
